{
  "schemaVersion": 1,
  "version": "2026.09.28",
  "verifiedAsOf": "2026-09-28",
  "operatorId": {
    "minimumAge": 18,
    "feeGbp": 12.34,
    "validYears": 1
  },
  "citations": {
    "registration": {
      "label": "CAA — Registering to fly drones and model aircraft",
      "url": "https://www.caa.co.uk/drones/open-category/getting-started-with-drones-and-model-aircraft/registering-to-fly-drones-and-model-aircraft/",
      "verified": "2026-09-28"
    },
    "operator": {
      "label": "CAA — Get an Operator ID",
      "url": "https://www.caa.co.uk/drones/open-category/getting-started-with-drones-and-model-aircraft/get-an-operator-id/",
      "verified": "2026-09-28"
    },
    "advanced": {
      "label": "CAA — Introduction to more advanced flying",
      "url": "https://www.caa.co.uk/drones/open-category/moving-on-to-more-advanced-flying/introduction-to-more-advanced-flying/",
      "verified": "2026-09-28"
    },
    "whereYouCanFly": {
      "label": "CAA — Where you can fly",
      "url": "https://www.caa.co.uk/drones/open-category/getting-started-with-drones-and-model-aircraft/where-you-can-fly/",
      "verified": "2026-09-28"
    },
    "flyLegally": {
      "label": "CAA — Getting what you need to fly legally",
      "url": "https://www.caa.co.uk/drones/open-category/drone-code/getting-what-you-need-to-fly-legally/",
      "verified": "2026-09-28"
    },
    "remoteId": {
      "label": "CAA — Remote ID programme page",
      "url": "https://www.caa.co.uk/drones/drone-regulations/policy-programmes/remote-id-rid/",
      "verified": "2026-09-28"
    },
    "restrictionZones": {
      "label": "NATS — UAS Restriction Zones",
      "url": "https://nats-uk.ead-it.com/cms-nats/opencms/en/uas-restriction-zones/",
      "verified": "2026-09-28"
    },
    "aip": {
      "label": "UK AIP ENR 5.1",
      "url": "https://nats-uk.ead-it.com/cms-nats/opencms/en/Publications/AIP/",
      "verified": "2026-09-28"
    },
    "notam": {
      "label": "NATS AIS — NOTAM briefing",
      "url": "https://nats-uk.ead-it.com/cms-nats/opencms/en/NOTAM/",
      "verified": "2026-09-28"
    }
  },
  "notes": {
    "legal": "Information only. The remote pilot remains responsible for every flight."
  }
}
